<template>
  <div class="CheckInOrder full-height  linear-main3">
    <ld-header
      @click-left="$router.push({path:'/allOrder?findType=1'})"
      transparent
      white
    >
      <div class="font12">
        订单号：{{ detail.orderNo }} {{ detail.tripType==1?'公':'私' }}
      </div>
    </ld-header>
    <div class="checkInOrderwrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <div class="mainbox">
          <div class="box">
            <div class="white list">
              <div class="font24 font-lg box">
                {{ detail.orderStatus|orderStatus }}<span v-show="detail.orderStatus!=5"> | {{ detail.payStatus==0?'待支付':'已支付' }} </span> <span v-show="detail.usageStatus"> | {{ detail.usageStatus|usageStatus }}</span>
              </div>
              <van-row
                v-show="detail.isAutoCancle"
                type="flex"
                align="center"
              >
                <van-col span="7">
                  支付时限剩余：
                </van-col>
                <van-col span="10">
                  <van-count-down
                    ref="countDown"
                    style="color:red;font-size:16px"
                    :time="times"
                    @finish="getDetail"
                    format=" HH 时 mm 分 ss 秒"
                  />
                </van-col>
              </van-row>
              <div>预订人：{{ detail.bookerName }}</div>
              <div>预订时间：{{ detail.bookDate }}</div>
              <div v-show="detail.payStatus==1">
                <div>支付时间：{{ detail.payDate }} {{ detail.payMothedName }}</div>
              </div>
            </div>
          </div>

          <div class="box">
            <van-cell>
              <van-row>
                <van-col span="12">
                  <span class="font-bold">优先值机</span>
                </van-col>
                <van-col
                  span="12"
                  class="text-right main-color"
                  @click="$dialog.alert({
                    title:'服务介绍',
                    messageAlign:'left',
                    message:detail.productDesc.split('\n').join('</br>')
                  })"
                >
                  服务介绍
                </van-col>
              </van-row>
            </van-cell>
            <van-cell :border="false">
              <img
                :src="detail.airlineImg"
                class="airIcon"
              >
              {{ detail.airlineName }}
            </van-cell>
            <van-cell class="bor-radus line-height-normal">
              <van-row>
                <van-col span="24">
                  <van-row>
                    <van-col
                      span="8"
                      class="text-left"
                    >
                      <div class="font20 black text-space-1">
                        {{ detail.deptCityName }}
                      </div>
                      <div class="font12 pad gray">
                        {{ detail.airportName }} {{ detail.terminal }}
                      </div>
                      <div class="font12 pad font-bold black">
                        {{ detail.flightDate }} {{ detail.flightTime }}
                      </div>
                    </van-col>
                    <van-col
                      span="8"
                      class="font10 text-nowrap gray pad-t-6 text-center"
                    >
                      <div class="font-bold black">
                        {{ detail.flightNo }}
                      </div>
                      <icon-arrow-line />
                    </van-col>
                    <van-col
                      span="8"
                      class="text-right"
                    >
                      <div class="font20 black text-space-1">
                        {{ detail.arrCityName }}
                      </div>
                      <div class="font12 pad gray">
                        {{ detail.toAirportName }} {{ detail.toTerminal }}
                      </div>
                      <div class="font12 pad gray">
                        {{ detail.flightToDate }} {{ detail.flightToTime }}
                      </div>
                    </van-col>
                  </van-row>
                </van-col>
              </van-row>
            </van-cell>
          </div>
          <div class="box">
            <van-field
              label="座位偏好"
              readonly
            >
              <template #input>
                {{ detail.seatType }}
              </template>
            </van-field>
          </div>

          <!--出行人 -->
          <traver
            :traveler-list="detail.obtAirportServerOrderPsgBeanList"
            :title="$t('C001','乘机人')"
            :disabled="true"
            :add-button="false"
            class="box"
          />
          <div
            class="box"
            v-if="detail.orderStatus==3||detail.orderStatus==4"
          >
            <van-field
              label="用户提示"
              readonly
              autosize
              type="textarea"
            >
              <template
                #input
                class="font12"
              >
                {{ detail.userTips }}
              </template>
            </van-field>
          </div>
          <!--  -->
          <travel-info
            ref="travelinfo"
            :travel-data="detail"
            :details="true"
            class="box"
          />
        </div>
      </mescroll-vue>
    </div>

    <!-- :price-list="priceList" -->
    <ld-tabbar
      ref="tabbar"
      class="bg-white shadow list"
    >
      <van-row
        class="full-width"
        type="flex"
        align="center"
        justify="space-between"
        gutter="8"
      >
        <van-col span="10">
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">{{ detail.totalAmount }}</span>
          <span class="font10 gray">&nbsp; {{ $t('E017','共') }}{{ detail.obtAirportServerOrderPsgBeanList.length }}人</span>
          <!-- <div
            class="font12"
            @click="$refs.tabbar.toggle()"
          >
            &nbsp;
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div> -->
        </van-col>
        <van-col
          span="7"
          v-show="detail.orderStatus<3&&detail.payStatus==0"
        >
          <ld-button
            defaults
            size="md"
            @click.native="cancel"
          >
            取消
          </ld-button>
        </van-col>
        <van-col
          span="7"
          v-show="detail.payStatus==0&&detail.orderStatus<3"
        >
          <ld-button
            main
            size="md"
            @click.native="pay"
          >
            去支付
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
  </div>
</template>

<script>
import {Field,Cell,Tag ,Popup,CountDown} from 'vant'
import { mapGetters } from 'vuex'
import { formatDate ,getDiffMinutes,getPreStrTime} from 'Utils/dateUtil'
import traver from 'Components/tk/traver'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'
import iconArrowLine from 'Common/iconArrowLine'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'CheckInOrder',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Popup.name]: Popup,
    [CountDown.name]: CountDown,
    ldTabbar,
    ldButton,
    traver,
    travelInfo,
    iconArrowLine,
    MescrollVue
  },
  data () {
    return {
      down:{use:false},
      choose:[{name:'不限'},{name:'第一排'},{name:'第二排'},{name:'安全出口'}],
      choose1:[{name:'不限'},{name:'靠窗'},{name:'中间'},{name:'过道'}],
      flightNo:'',
      departDate:formatDate(new Date()).date,
      expiryDate: new Date(),
      airportName:'',
      detail:{
        obtAirportServerOrderPsgBeanList:[]
      },
      orderId:'',
      times:60*60*1000
    }
  },
  computed: {
    ...mapGetters({
      sysType:'sysType',
      userInfo:'userInfo',
      // travelerList: 'checkIn/travelerList',
    }),
    priceList(){
      let cxr=this.detail.obtAirportServerOrderPsgBeanList||[]
      let arr=[]
      if(cxr.length>0){
        arr=[
          {name:'成人价格',price:this.detail.salePrice,amount:cxr.length,unit:'/人'},
        ]
      }
      return arr
    },
  },
  created () {
    this.orderId=this.$route.query.orderId
    this.getDetail()
  },
  methods:{
    getDetail(){
      this.$api['airService/orderDetail']({orderId:this.orderId}).then((res) => {
        let cache=res.data||{}
        this.detail=cache
        if(cache.isAutoCancle ==1){
          this.times=cache.autoCancleTime
        }
        // let layter= getPreStrTime(cache.bookDate,1)
        // let times=getDiffMinutes(formatDate(new Date()).datehms,layter)
        // if(times<=60&&times>1){
        // 	this.times=times*60*1000
        // 	this.$refs.countDown.start()
        // }
      })
    },
    cancel(){
      this.$dialog.confirm({
        title:'提示',
        message:'确认取消订单？'
      }).then(()=>{
        this.$api['airService/cancel']({orderId:this.orderId,version:this.detail.version,orderFrom:this.sysType}).then((res) => {
          this.$dialog.alert({
            title:'提示',
            message:'订单已取消！'
          }).then(()=>{
            this.getDetail()
          })
        })
      })
    },
    pay(){
      this.$router.push({path:'/pay/payment',query:{orderType:'11030',orderId:this.orderId}})
    },
  },
  watch: {
  },
  filters:{
    orderStatus:function(type){
      var obj={'1':'已预订','2':'已调度','3':'已出票','4':'已完成','5':'已取消'}//1标准
      return obj[type]||''
    },
    usageStatus:function(type){
      var obj={'1':'未使用','2':'已使用','3':'已过期'}
      return obj[type]||''
    },
  }
}
</script>

<style lang="less" scoped>
@import '~Assets/styles/business';

.mainbox{
    padding: 0 8px 50px;
}
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
.checkInOrderwrapper{
    height: calc(100vh - 96px);
    overflow: hidden;
}
</style>
